<template>
	<transition name="modal">
		<div id="ecommerce_product_edit" class="modal-mask" @click="cancelContent">
			<div class="modal-wrapper" role="document" style="overflow-y:auto;position:absolute">
				<div class="modal-container modal-dialog">
					<div class="modal-content" @click.stop>
						<div class="modal-header">
							<div class="row">
								<div class="col-xs-10">
									Edit Product
								</div>
								<div class="col-xs-2">

								<button type="button" class="close" @click="cancelContent" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
								</div>

							</div>
							
						</div>
						<div class="modal-body" v-if="product">
							<div class="row">
								<div class="col-xs-12">
									<div class="form-group" :class="{'has-error': errors.has('categoryInput')}">
										<label for="categoryInput">Category *</label>
										<select-category :pageid="pageid" v-model="category" :selected="currentCategory" @onChangeCategory="onChangeCategory" data-vv-name="categoryInput" data-vv-as="Category" v-validate="'required'"></select-category>
										<p class="text-error" v-show="errors.has('categoryInput')">{{ errors.first('categoryInput') }}</p>
									</div>

									<!--<div class="form-group">
										<label for="subCategoryInput">Sub Category</label>
										<select name="subCategory" class="form-control"  v-model="product.subcategoryid">
											<option value="0" :selected="product.subcategoryid == 0">Select Sub-Category</option>
											<template v-if="currentCategory">
												<option :value="subcategory.id" v-for="(subcategory,index) in currentCategory.subcategories" :selected="subcategory.id == product.subcategoryid" :key="'subcategory_'+index">{{ subcategory.name }}</option>
											</template>
										</select>
									</div>-->
								</div>
								<div class="col-xs-12 col-sm-5">
									<div class="pb-3" style="padding-top:15px;" :class="{'has-error': errors.has('uploadMultipleFile')}">
										
										<!-- <uploadfile v-model="product.photourl"></uploadfile> -->
										<upload-multiple-file v-model="productImages" :max="3" data-vv-name="uploadMultipleFile" data-vv-as="Preview Image" v-validate="'required'"></upload-multiple-file>
										
										<p class="text-error" v-show="errors.has('uploadMultipleFile')">{{ errors.first('uploadMultipleFile') }}</p>
									</div>
								</div>
								<div class="col-xs-12 col-sm-7">

									<div class="form-group" :class="{'has-error': errors.has('nameInput')}">
										<label for="nameInput">Name *</label>
										<input type="text" class="form-control" ref="name" id="nameInput" name="nameInput" data-vv-as="Name" aria-describedby="name" placeholder="Name" v-model="product.name" v-validate="'required'">
										<p class="text-error" v-show="errors.has('nameInput')">{{ errors.first('nameInput') }}</p>
									</div>

									<div class="form-group" :class="{'has-error': errors.has('codeInput')}">
										<label for="codeInput">SKU *</label>
										<input type="text" class="form-control" id="codeInput" name="codeInput" data-vv-as="SKU" aria-describedby="SKU" placeholder="SKU" v-model="product.code" v-validate="'required'">
										<p class="text-error" v-show="errors.has('codeInput')">{{ errors.first('codeInput') }}</p>
									</div>

									<div class="form-group" :class="{'has-error': errors.has('priceInput')}">
										<label for="priceInput">Price *</label>
										<div class="form-inline">
											<div style="padding: 6px 12px;border-radius: 50%;display: inline-block;background: #eee;margin-right: 5px;">{{currencySign}}</div><input type="text" class="form-control" id="priceInput" name="priceInput" data-vv-as="Price" ref="price" aria-describedby="price" placeholder="Price" v-model="product.price" v-validate="'required|decimal|min_value:1'"  style="max-width: 150px;display: inline;" @change="onChangePrice"> &nbsp;
											<p class="text-error" v-show="errors.has('priceInput')">{{ errors.first('priceInput') }}</p>
										</div>
									</div>

									<div class="form-group" :class="{'has-error': errors.has('discountPriceInput')}">
										<label for="dicountPriceInput">Sale Price *</label>
										<div class="form-inline">
											<div style="padding: 6px 12px;border-radius: 50%;display: inline-block;background: #eee;margin-right: 5px;">{{currencySign}}</div>
											<input type="text" class="form-control" id="discountPriceInput" name="discountPriceInput" data-vv-as="Sale Price" aria-describedby="Sale Price" placeholder="Sale Price" v-model="product.discountprice" v-validate="'required|decimal|min_value:1|isLessThanOrEqual:price'" style="max-width: 150px;display: inline;"> &nbsp;
											<p class="text-error" v-show="errors.has('discountPriceInput')">{{ errors.first('discountPriceInput') }}</p>
										</div>
									</div>

									<div class="form-group">
										<label for="discountPercentage">Discount Percentage</label>
										<div class="form-inline">
											<span v-if="product.discountprice && parseFloat(product.discountprice) > 0 && parseFloat(product.price) >= parseFloat(product.discountprice)" style="padding:5px 10px;background:red;color:white;">{{( (product.price - product.discountprice) / product.price ) * 100 | numberFormat }} %</span> <span v-else style="padding:5px 10px;background:#eee;color:white;">0 %</span>
										</div>
									</div>
								</div>

								<div class="col-xs-12">
									<div class="form-group" :class="{'has-error': errors.has('descriptionInput')}">
										<label for="nameInput">Product Detail *</label>
										<textarea type="text" class="form-control" id="descriptionInput"  style="resize:vertical"  name="descriptionInput" data-vv-as="Description" aria-describedby="description" placeholder="Description" row="3" v-model="product.description" v-validate="'required'"></textarea>
										<p class="text-error" v-show="errors.has('descriptionInput')">{{ errors.first('descriptionInput') }}</p>
									</div>

									<hr>
									<div :class="{'has-error': errors.has('options[]') || errors.has('quantity[]') || errors.has('price[]') || errors.has('saleprice[]')}">
										<p class="text-error" v-show="errors.has('options[]')">{{ errors.first('options[]') }}</p>
										<p class="text-error" v-show="errors.has('quantity[]')">{{ errors.first('quantity[]') }}</p>
										<p class="text-error" v-show="errors.has('price[]')">{{ errors.first('price[]') }}</p>
										<p class="text-error" v-show="errors.has('saleprice[]')">The Sale Price can not more than Price or less than zero</p>
									</div>

									<product-stock v-model="productstock" @close="close()" @deleteStock="deleteStock"></product-stock>
									

									<hr>	

									<div class="text-center">
										<a class="text" href="javascript:void(0);" @click="showAdvanced = !showAdvanced">Advanced <i class="fa " :class="{'fa-angle-down' : showAdvanced , 'fa-angle-up' : !showAdvanced}"></i></a>
									</div>

									<template v-if="showAdvanced">

										<div class="form-group" :class="{'has-error' : errorTag.length > 0}">
											<label for="keywordInput">Keywords</label>
											<vue-tags-input v-model="tag" :tags="tags" @tags-changed="newTags => tags = newTags" @before-adding-tag="checkTag" />
												<p class="text-error" v-if="errorTag.length > 0">
														<template v-if="errorTag.includes('duplicate')">
																Duplicate quick reply
														</template>								
												</p>
										</div>
										 <hr>
										<!--

										<div class="form-group">
											<label for="buttonActionInput">Button Action</label>
											<select name="buttonAction" class="form-control" v-model="product.buttonaction">
												<option value="none">None</option>
												<option value="url">Url</option>
												<option value="buy">Buy</option>
											</select>
										</div> -->

										<div class="form-group" v-if="product.buttonaction == 'url' || product.buttonaction == 'buy'">
											<label for="buttonNameInput">Button Name</label>
											<input type="text" class="form-control" id="buttonNameInput" aria-describedby="Button Name" placeholder="Button Name" v-model="product.buttonname">
										</div>

										<div class="form-group" v-if="product.buttonaction == 'url'">
											<label for="buttonUrlInput">Product Url</label>
											<input type="text" class="form-control" id="buttonUrlInput" aria-describedby="Product Url" placeholder="Product Url" v-model="product.buttonurl">
										</div> 
									</template>
									
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<div class="row">
								<div class="col-xs-6 text-left">
									<a href="javascript:void(0);" class="btn btn-secondary" @click="onDeleteProduct(product.id)">Delete Product</a>
								</div>
								<div class="col-xs-6 text-right">
									<button type="button" class="btn btn-primary" @click="saveProduct">Save</button>
									<button type="button" class="btn btn-secondary" data-dismiss="modal" @click="cancelContent()">Cancel</button>
								</div>
							</div>
							
						</div>
					</div>

				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import SelectCategory from "./SelectCategory";
import uploadfile from "@/components/elements/uploadfile";
import api from "@/api";
import VueTagsInput from "@johmun/vue-tags-input";
import UploadMultipleFile from "@/components/elements/UploadMultipleFile";
import ProductStock from "./ProductStock";
// import { clearInterval } from 'timers';


export default {
  props: ["value", "category"],
  data: function() {
    return {
      productImages: [],
      product: null,
      currentCategory: this.value.categoryid,
      categories: null,
      tag: "",
      currentView: "product",
			showAdvanced: false,
			deletelist: [],
			productstock: [],

			loadingStock: null,
			stock_process_count: 0,

			errorTag: []
    };
  },
  computed: {
    currencySign: function() {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case "THB":
            return "฿";

          default:
            return "$";
        }
      }
      return "$";
    },
    pageid: function() {
      return this.$store.state.selectedBot.pageid;
    },
    tags: {
      get() {
        let vm = this;
        if (vm.product.keyword != "") {
          var tags = vm.product.keyword.split(",");
          var result = [];
          $.each(tags, function(index, val) {
            result.push({ text: val });
          });
          return result;
        } else {
          return [];
        }
      },
      set(value) {
        let vm = this;
        var result = [];
        $.each(value, function(index, val) {
          result.push(val.text);
        });
        vm.product.keyword = result.join(",");
      }
    }
  },
  components: {
    SelectCategory,
    uploadfile: uploadfile,
    VueTagsInput,
    UploadMultipleFile,
    ProductStock
  },
  mounted: function() {
	let vm = this;
	vm.product = Object.assign({}, vm.value);
	vm.cached_product = Object.assign({}, vm.value);

	vm.product.buttonaction = 'url'
	vm.cached_product.buttonaction = 'url'

	vm.productstock = []
	$.each(vm.value.productstock,function(index, val){
		vm.productstock.push(Object.assign([], val))
	})

	vm.cached_productstock = []
	$.each(vm.value.productstock,function(index, val){
		vm.cached_productstock.push(Object.assign([], val))
	})

    vm.productImages = vm.product.photourl.split(";;");
    vm.currentCategory = vm.product.categoryid;
    // vm.$refs.name.focus();

    document.addEventListener("keydown", e => {
      if (e.keyCode == 27) {
        vm.$emit("close");
      }
    });
  },
  methods: {
    onChangeCategory: function(payload) {
      this.currentCategory = payload;
    },
    saveProduct: function() {
      let vm = this;
      vm.$validator.validateAll().then(result => {
        if (!result) {
					// do stuff if not valid.
					vm.goToErrorInput()
          return false;
				}
				let product = Object.assign({}, vm.product);
				product.productstock = []
				$.each(vm.productstock,function(index, val){
					product.productstock.push(Object.assign([], val))
				})
				product.price = parseFloat(product.price)
				product.discountprice = parseFloat(product.discountprice)
        product.pageid = vm.pageid;
        product.photourl = vm.productImages.join(";;");
				product.categoryid = vm.currentCategory;
				
				vm.$store.dispatch("loading");
        api.editProduct(product, function(error, response) {
					vm.saveStock(function(){
						vm.cached_product = Object.assign({}, vm.product);

						vm.cached_productstock = []
						$.each(vm.productstock,function(index, val){
							vm.cached_productstock.push(Object.assign([], val))
						})

						vm.$emit('input',product)
						vm.$store.dispatch('loading')
						vm.$emit('close')
					})
        });
      });
    },
    saveStock: function(callback) {
		let vm = this

		let productstock = []

		vm.stock_process_count = vm.productstock.length + vm.deletelist.length

		$.each(vm.productstock, function(index, value){
			let stock = {
				id: value[0],
				option: value[1], 
				productid: vm.product.id, 
				quantity: value[2], 
			}

			
			if (value[3] == '' || parseFloat(value[3]) == 0) {
				stock.price = null
			} else {
				stock.price = value[3]
			}

			if (value[4] == '' || parseFloat(value[4]) == 0) {
				stock.discountprice = null
			} else {
				stock.discountprice = value[4]
			}



			if (value[0] == null) {
				api.saveProductStock(stock,function(error, response){
					if (error) {
						console.error(error)
					}
					vm.productstock[index][0] = response.productstockid
					vm.stock_process_count--;
				})
			} else {
				api.editProductStock(stock,function(error, response){
					if (error) {
						console.error(error)
					}
					vm.stock_process_count--;
				})
			}
		})

		$.each(vm.deletelist,function(index,val){
			api.deleteProductStock(val,function(error, response){
				if (error) {
					console.error(error)
				}
				vm.stock_process_count--;
			})
		})

		vm.loadingStock = setInterval(function(){
			if (vm.stock_process_count == 0) {
				if (vm.loadingStock) {
					clearInterval(vm.loadingStock)
				}
				callback()
			}
		},1000)

		
	},
	deleteStock: function(id){
		this.deletelist.push(id)
	},
    checkTag: function(obj) {
      this.errorTag = []
			if(this.tags.map(t => t.text).indexOf(obj.tag.text) !== -1) this.errorTag.push('duplicate')
      else obj.addTag();
    },
    onDeleteProduct: function(id) {
      if (confirm("Do you want to delete this?")) {
        let vm = this;
        vm.$store.dispatch("loading");
        api.deleteProduct(id, function(error, response) {
          if (error) {
						vm.$store.dispatch("loading");
            console.error(error);
            return;
          }

          vm.$emit("productDeleted");
          vm.$emit("close");
          vm.$store.dispatch("loading");
        });
      }
	},
	cancelContent: function(){
		var vm = this
		vm.product = Object.assign({}, vm.cached_product);
		vm.productstock = []
		$.each(vm.cached_productstock,function(index, val){
			vm.productstock.push(Object.assign([], val))
		})

		vm.$emit('close')
	},
	onChangePrice: function(){
		this.product.discountprice = this.product.price;				
	}
  },
  watch: {
    value: function(newVal, oldVal) {
		let vm = this;
		vm.product = Object.assign({}, vm.value);
		vm.cached_product = Object.assign({}, vm.value);

		vm.productstock = []
		$.each(vm.value.productstock,function(index, val){
			vm.productstock.push(Object.assign([], val))
		})

		vm.cached_productstock = []
		$.each(vm.value.productstock,function(index, val){
			vm.cached_productstock.push(Object.assign([], val))
		})

		vm.product.buttonaction = 'url'
		vm.cached_product.buttonaction = 'url'

		vm.productImages = vm.product.photourl.split(";;");
    },
    // "product.price": function(newVal, oldVal) {
		// 	if (newVal != oldVal) {
		// 		this.product.discountprice = newVal;				
		// 	}
    // }
  }
};
</script>

<style scroped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ModalEditProduct.vue